import { render, staticRenderFns } from "./price_plan_form.vue?vue&type=template&id=d570a9bc&"
import script from "./price_plan_form.vue?vue&type=script&lang=js&"
export * from "./price_plan_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports